const fBackToTop = () => {
  const oBackToTopButton = document.querySelector('.js-to-top');

  const scrollToTop = () => {
      scrollIt(0, 400, 'easeInQuad');

      var list4 = document.querySelectorAll('.configuratorfilters--scrollable');
      if (list4) {
          list4[0].scrollTop = 0;
      }

  };

  oBackToTopButton.addEventListener('click', scrollToTop);
};
